import React from 'react';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import theme from './theme';

// Components
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Clients from './components/Clients';
import About from './components/About';
import Services from './components/Services';
import Gallery from './components/ServicesShowcase'; // New Component for Site Photos
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Team from './components/team';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: 'background.default' }}>
        <Navbar />
        <main>
          <Hero />
          <About />
          <Gallery />
          <Services />
          <Projects />
          <Team />
          <Clients />
          <Contact />
        </main>
        <Footer />
      </Box>
    </ThemeProvider>
  );
}

export default App;